import { Link } from "react-router-dom";
import "./Categories.css";
import { useContext } from "react";
import { ConfigContext } from "../../../assets/contexts/configContext";
import {
  CATALOG_MAIN_LINK,
  FINE_ART_CATEGORY_LINK,
  HERMES_BAGS_CATEGORY_LINK,
  IMG_PLACEHOLDER_PRODUCT,
  JEWELRY_CATEGORY_LINK,
  WATCHES_CATEGORY_LINK,
} from "../../../assets/utils/constants";
import { CategoryLinkIcon } from "../../../assets/icons/customCategorie";

export function CategoriesNoText() {
  return <Categories show_text={false} />;
}

export function CategoriesWithText() {
  return <Categories show_text={true} />;
}

/**
 * Функция, которая определяет, какое слово (или слова) использовать
 * для подписи количества в зависимости от категории.
 */
function getCountText(categoryLink, count) {
  let singular, plural;

  switch (categoryLink) {
    case WATCHES_CATEGORY_LINK:
    case JEWELRY_CATEGORY_LINK:
      singular = "Brand";
      plural = "Brands";
      break;
    case HERMES_BAGS_CATEGORY_LINK:
      singular = "Model";
      plural = "Models";
      break;
    case FINE_ART_CATEGORY_LINK:
      singular = "Product";
      plural = "Products";
      break;
    default:
      singular = "Product";
      plural = "Products";
  }

  return count === 1 ? singular : plural;
}

function Categories({ show_text }) {
  const config = useContext(ConfigContext);

  const { initialConstants, cardTokens } = config;
  const { FIRST_LEVEL_CATEGORIES } = initialConstants;
  const { image_radius } = cardTokens;

  // Порядок отображения
  const DESIRED_ORDER = [
    WATCHES_CATEGORY_LINK,
    JEWELRY_CATEGORY_LINK,
    HERMES_BAGS_CATEGORY_LINK,
    FINE_ART_CATEGORY_LINK,
  ];

  // Фильтруем и сортируем категории в заданном порядке
  const ONLY_4_CATEGORIES = FIRST_LEVEL_CATEGORIES
    .filter((item) => DESIRED_ORDER.includes(item.translit_name))
    .sort(
      (a, b) =>
        DESIRED_ORDER.indexOf(a.translit_name) -
        DESIRED_ORDER.indexOf(b.translit_name)
    );

  return (
    <div className="custom-categories">
      <p className="custom-categories__title">Categories</p>
      <div className="custom-categories__items">
        {ONLY_4_CATEGORIES && ONLY_4_CATEGORIES.length > 0
          ? ONLY_4_CATEGORIES.map((item) => {
              // Определяем, какое количество использовать:
              // в приоритете item.count, если его нет — тогда item.published_count
              const itemCount = item.count ?? item.published_count;

              return (
                <Link
                  className="custom-categories__item"
                  to={`/${CATALOG_MAIN_LINK}/${item.translit_name}`}
                  key={item.translit_name}
                >
                  <CategoryLinkIcon
                    mainClassName={"custom-categories__link-icon"}
                    fillClassName={"custom-categories__link-icon-fill"}
                  />
                  <div className="custom-categories__img-box">
                    <img
                      className="custom-categories__img"
                      src={
                        item.file ? item.file.urls.orig : IMG_PLACEHOLDER_PRODUCT
                      }
                      alt={item.name}
                    />
                  </div>
                  <div className="custom-categories__item-info">
                    {/* <div className="custom-categories__item-count-box">
                      <p className="custom-categories__item-count">{itemCount}</p>
                      <p className="custom-categories__item-count-title">
                        {getCountText(item.translit_name, itemCount)}
                      </p>
                    </div> */}
                    <p className="custom-categories__item-name">{item.name}</p>
                  </div>
                </Link>
              );
            })
          : null}
      </div>
    </div>
  );
}

export default Categories;
